import * as React from "react";
import { LobTitleProps } from "./typings";
import { useLocalization } from "@shared-ui/localization-context";

export const LobTitle: React.FunctionComponent<LobTitleProps> = ({ lobState }) => {
  const { formatText } = useLocalization();
  const title = formatText(lobState.config.heading.locToken);

  return <h1 className="uitk-type-heading-600">{title}</h1>;
};
